
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import LineStyleIcon from '@mui/icons-material/LineStyle';
import RoundedCornerIcon from '@mui/icons-material/RoundedCorner';
import CategoryIcon from '@mui/icons-material/Category';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import AutofpsSelectIcon from '@mui/icons-material/AutofpsSelect';
import SettingsIcon from '@mui/icons-material/Settings';
import PolylineIcon from '@mui/icons-material/Polyline';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AssignmentIcon from '@mui/icons-material/Assignment';



const PharmaAdmin = {
  id: '5',
  title: 'Platform Manager',
  type: 'group',
  role: ' PHARMA_OMS_ADMIN',
  children: [
    {
      id: 'taskmgmt',
      title: 'Task Management',
      type: 'item',
      url: '/',
      bottomMenu:'TASK-MANAGEMENT',
      icon: AssignmentIcon
    }
    ,
    {
      id: 'tagging',
      title: 'Tagging',
      type: 'item',
      url: '/',
      bottomMenu:'TAGGING',
      icon: LocalOfferIcon
    },

  ]
};

export default PharmaAdmin;